import {combineReducers} from 'redux'
import Immutable from 'seamless-immutable'
import types from '../../../actions/types'

export const data = (state = {posted: [], notPosted: [], invoiceMap: {}, problemList: []}, action) => {
  switch (action.type) {
    case types.ACCOUNTING_INVOICE_SHOW_POST_REPORT:
      return action.data
    case types.ACCOUNTING_INVOICE_HIDE_POST_REPORT:
      return {posted: [], notPosted: [], invoiceMap: {}, problemList: []}
    default:
      return state
  }
}

export const isShown = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.ACCOUNTING_INVOICE_SHOW_POST_REPORT:
      return Immutable(true)
    case types.ACCOUNTING_INVOICE_HIDE_POST_REPORT:
      return Immutable(false)
    default:
      return state
  }
}

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.ACCOUNTING_TAX_CODE_READ_ATTEMPT:
      return true
    case types.ACCOUNTING_TAX_CODE_READ_SUCCESS:
      return false
    case types.ACCOUNTING_POST_REPORT_LOADING:
      return action.val
    default:
      return state
  }
}

export const accountingTaxCodes = (state = [], action) => {
  switch (action.type) {
    case types.ACCOUNTING_TAX_CODE_READ_SUCCESS:
      return action.data
        ? action.data
        : state
    default:
      return state
  }
}

export default combineReducers({
  data,
  isShown,
  isLoading,
  accountingTaxCodes,
})
